"use client"

import { useTheme } from "next-themes"
import { Toaster } from "react-hot-toast"
import type React from "react"

type ToasterProps = Partial<React.ComponentProps<typeof Toaster>>

const ToasterComponent = ({ ...props }: ToasterProps) => {
    const { theme = "system" } = useTheme()

    return (
        <Toaster
            position="top-right"
            gutter={8}
            toastOptions={{
                duration: 3000,
                className: "!bg-background text-sm !text-foreground border shadow-lg",
                style: {
                    background: theme === 'dark' ? 'rgb(15, 15, 15)' : 'white',
                    color: theme === 'dark' ? 'white' : 'black',
                },
            }}
            {...props}
        />
    )
}

export default ToasterComponent